/* =========================
   PEGUU — VERIFY EMAIL
========================= */

(() => {
  "use strict";

  const root = document.querySelector("[data-peguu-verify-email]");

  if (!root) {
    return;
  }

  const message = root.querySelector("[data-verify-email-message]");
  const actions = root.querySelector("[data-verify-email-actions]");
  const continueLink = root.querySelector("[data-verify-email-continue]");
  const resendWrap = root.querySelector("[data-verify-email-resend-wrap]");
  const resendButton = root.querySelector("[data-verify-email-resend]");
  const apiBaseUrl = window.PeguuApi.endpoint("customers");

  const getToken = () => {
    const params = new URLSearchParams(window.location.search);
    return String(params.get("token") || "").trim();
  };

  const setMessage = (text) => {
    if (message) {
      message.textContent = text;
    }
  };

  const setState = (state) => {
    root.dataset.verifyState = state;
  };

  const showContinue = () => {
    if (actions) {
      actions.hidden = false;
    }
  };

  const hideContinue = () => {
    if (actions) {
      actions.hidden = true;
    }
  };

  const showResend = () => {
    if (!resendWrap) {
      return;
    }

    const authenticated =
      typeof window.PeguuAuth?.isAuthenticated === "function" &&
      window.PeguuAuth.isAuthenticated();

    resendWrap.hidden = !authenticated;
  };

  const hideResend = () => {
    if (resendWrap) {
      resendWrap.hidden = true;
    }
  };

  const parsePayload = async (response) => {
    let payload = null;

    try {
      payload = await response.json();
    } catch (error) {
      payload = null;
    }

    if (!response.ok || payload?.success !== true) {
      const error = new Error(
        payload?.message || "No fue posible verificar tu correo."
      );
      error.status = response.status;
      error.payload = payload;
      throw error;
    }

    return payload;
  };

  const validateToken = async (token) => {
    const url = new URL(`${apiBaseUrl}/validate-verify-token`);
    url.searchParams.set("token", token);

    const response = await fetch(url.toString(), {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    // Si el endpoint no existe aún, seguimos con el POST de verificación.
    if (response.status === 404 || response.status === 501) {
      return null;
    }

    return parsePayload(response);
  };

  const verifyEmail = async (token) => {
    const response = await fetch(`${apiBaseUrl}/verify-email`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token }),
    });

    return parsePayload(response);
  };

  const refreshSession = async () => {
    if (typeof window.PeguuAuth?.refreshCustomer !== "function") {
      return;
    }

    if (
      typeof window.PeguuAuth?.isAuthenticated === "function" &&
      !window.PeguuAuth.isAuthenticated()
    ) {
      return;
    }

    try {
      await window.PeguuAuth.refreshCustomer();
    } catch (error) {
      console.warn(
        "Peguu Verify Email: no fue posible actualizar la sesión.",
        error
      );
    }
  };

  const handleResend = async () => {
    if (!resendButton || resendButton.disabled) {
      return;
    }

    if (typeof window.PeguuAuth?.requestEmailVerification !== "function") {
      setMessage("Inicia sesión para solicitar un nuevo correo de verificación.");
      return;
    }

    const originalText = resendButton.textContent;
    resendButton.disabled = true;
    resendButton.textContent = "Enviando…";

    try {
      await window.PeguuAuth.requestEmailVerification();
      setMessage(
        "Te enviamos un nuevo correo de verificación. Revisa tu bandeja o el correo no deseado. El enlace anterior ya no es válido."
      );
      resendButton.textContent = "Correo enviado";
    } catch (error) {
      resendButton.disabled = false;
      resendButton.textContent = originalText;
      setMessage(
        error?.status === 429
          ? "Demasiados intentos. Espera un momento y vuelve a intentar."
          : error?.message ||
              "No fue posible reenviar el correo de verificación."
      );
    }
  };

  const initialize = async () => {
    const token = getToken();

    hideContinue();
    hideResend();
    setState("loading");

    if (!token) {
      setState("error");
      setMessage(
        "Este enlace no incluye un token de verificación. Revisa el correo o solicita uno nuevo."
      );
      showResend();
      return;
    }

    try {
      await validateToken(token);
      await verifyEmail(token);
      await refreshSession();
      setState("success");
      setMessage("Email verificado. Ya puedes completar tu compra.");
      showContinue();
    } catch (error) {
      setState("error");
      setMessage(
        error?.message ||
          "No fue posible verificar tu correo. El enlace puede estar usado o vencido."
      );
      showResend();
    }
  };

  if (continueLink && root.dataset.paymentUrl) {
    continueLink.href = root.dataset.paymentUrl;
  }

  resendButton?.addEventListener("click", handleResend);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }
})();
